import Ckeckoutcontainer from './ckeckoutContainer';
import { SIZE } from './constants';

export default Ckeckoutcontainer;
export { SIZE };